export const DefaultParent = ({ children }) => children(null)
